const API_KEY = 'vdhy8wwjUJrwhxFpfuECTiAW'
const SCHEDULE_URL = 'https://api.shippersedge.com/schedule/shipment/'
const CONSOLIDATION_URL = 'https://api.shippersedge.com/schedule/isConsolidation/'

// Schedule (create or change) an appointment
export const scheduleAppointment = async ({ type, option, existingAppts, shipment, adminDate, cftoken }) => {
    const requestType = existingAppts.length === 0 ? 'eventCreate' : 'eventChange'
    const body = {
        requestType,
        shipmentId: shipment.id,
        responsibleUser: 'quickSchedule',
        carrierRequestVersion: 2,
        dockId: option.dock,
        timeIn: option.start,
        timeOut: option.end,
        type,
        cftoken: cftoken ?? null
    }
    if (adminDate) body.adminDate = adminDate

    try {
        const res = await fetch(SCHEDULE_URL, {
            method: 'POST',
            headers: { 'x-api-key': API_KEY, 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
            redirect: 'follow'
        })
        return res.ok
    } catch {
        return false
    }
}

// Cancel an existing appointment
export const cancelAppointment = async ({ appointment, locationId }) => {
    const body = {
        ...appointment,
        requestType: 'eventRemove',
        responsibleUser: 'carrier',
        locationId
    }
    try {
        const res = await fetch(SCHEDULE_URL, {
            method: 'POST',
            headers: { 'x-api-key': API_KEY, 'Content-Type': 'application/json;charset=UTF-8' },
            body: JSON.stringify(body),
            redirect: 'follow'
        })
        return res.ok
    } catch {
        return false
    }
}

// Check if a driverCode is a consolidation (multi-stop)
export const checkConsolidation = async (driverCode) => {
    try {
        const res = await fetch(`${CONSOLIDATION_URL}${driverCode}`, {
            method: 'GET',
            headers: { 'x-api-key': API_KEY },
            redirect: 'follow'
        })
        if (!res.ok) return null
        return await res.json()
    } catch {
        return null
    }
}
